module.exports = __webpack_public_path__ + "static/media/ethereum.a811e1d0.png";